/* src/app/views/auth/components/auth/auth.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.auth-wrapper {
  display: flex;
}
.auth-brand-container,
.auth-action-container {
  position: relative;
  flex: 1;
  background-color: #ffffff;
}
.brand-wrapper {
  background-size: cover;
}
.image-container {
  height: 100vh;
  width: 50vw;
  position: relative;
  filter: brightness(0.5);
}
.image-container img {
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  z-index: 0;
}
.auth-flow-wrapper,
.brand-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
.auth-flow-container,
.brand-logo-container {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
}
.auth-flow-container {
  max-width: 28rem;
}
.brand-logo-container {
  width: 50%;
  text-align: center;
}
.brand-logo {
  width: 16rem;
}
.auth-flow-title {
  font-size: 2rem;
  text-align: left;
  line-height: 3.125rem;
  color: #2c4058;
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.auth-flow-subtext {
  margin: 1rem 0;
  font-size: 1rem;
  line-height: 1.125rem;
  text-align: left;
  color: #666972;
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.software-version {
  position: absolute;
  bottom: 0;
  margin-left: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  color: #ffffff;
}
/*# sourceMappingURL=auth.component.css.map */
